/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-sidebar-width: Sidebar width.
 * @prop --sy-sidebar-height: Sidebar height.
 * @prop --sy-sidebar-color: Sidebar color.
 * @prop --sy-sidebar-background-color: Sidebar background color.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  position: fixed;
  z-index: 1050;
  display: block;
  height: 100%;
}

.sy-sidebar {
  position: absolute;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  width: var(--sy-sidebar-width, var(--sy-spacer-12));
  height: var(--sy-sidebar-height, 100%);
  color: var(--sy-sidebar-color, var(--sy-foreground-high-emphasis));
  background-color: var(--sy-sidebar-background-color, var(--sy-surface));
}

:host([hide-backdrop]) sy-backdrop {
  --sy-backdrop-background-color: transparent;
}